import {
  createContext,
  useCallback,
  useContext,
  useMemo,
  useState,
  type ReactNode,
} from "react";
import { Drawer } from "@mui/material";

import { SncrNumeracoesPanel } from "../components/SncrNumeracoesPanel";

type SncrNumeracoesDrawerContextValue = {
  open: boolean;
  openSncrNumeracoes: () => void;
  closeSncrNumeracoes: () => void;
};

const SncrNumeracoesDrawerContext =
  createContext<SncrNumeracoesDrawerContextValue | null>(null);

export function SncrNumeracoesDrawerProvider({
  children,
}: {
  children: ReactNode;
}) {
  const [open, setOpen] = useState(false);

  const openSncrNumeracoes = useCallback(() => setOpen(true), []);
  const closeSncrNumeracoes = useCallback(() => setOpen(false), []);

  const value = useMemo(
    () => ({ open, openSncrNumeracoes, closeSncrNumeracoes }),
    [open, openSncrNumeracoes, closeSncrNumeracoes],
  );

  return (
    <SncrNumeracoesDrawerContext.Provider value={value}>
      {children}
      <Drawer
        anchor="right"
        open={open}
        onClose={closeSncrNumeracoes}
        disableEnforceFocus
        ModalProps={{ keepMounted: false }}
        PaperProps={{
          sx: {
            width: { xs: "100%", sm: 520 },
            maxWidth: "100vw",
            display: "flex",
            flexDirection: "column",
          },
        }}
      >
        {open ? (
          <SncrNumeracoesPanel onClose={closeSncrNumeracoes} />
        ) : null}
      </Drawer>
    </SncrNumeracoesDrawerContext.Provider>
  );
}

export function useSncrNumeracoesDrawer() {
  const ctx = useContext(SncrNumeracoesDrawerContext);
  if (!ctx) {
    throw new Error(
      "useSncrNumeracoesDrawer deve ser usado dentro de SncrNumeracoesDrawerProvider",
    );
  }
  return ctx;
}

export function useSncrNumeracoesDrawerOptional() {
  return useContext(SncrNumeracoesDrawerContext);
}
